var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VApp",
    { staticClass: "app-container" },
    [
      _c(
        "VMain",
        [
          _c(
            "v-slide-x-transition",
            { attrs: { mode: "out-in" } },
            [_c("router-view")],
            1
          ),
          _vm._v(" "),
          _c("Banner"),
          _vm._v(" "),
          _c("NavigationButton"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }